import BaseBlock from "./BaseBlock";
import {NavigationOptions, PaginationOptions} from "swiper/types";

abstract class BaseSliderBlock extends BaseBlock {

	protected getDefaultNavigation(wrapper: HTMLElement | null = null): NavigationOptions {
		if (wrapper === null) {
			wrapper = this.block;
		}

		return {
			prevEl: <HTMLElement>wrapper.querySelector(".slider-btn-prev"),
			nextEl: <HTMLElement>wrapper.querySelector(".slider-btn-next"),
		}
	}

	protected getDefaultPagination(wrapper: HTMLElement|null =  null): PaginationOptions {
		if (wrapper === null) {
			wrapper = this.block;
		}

		return <PaginationOptions>{
			el: <HTMLElement>wrapper.querySelector(".slider-pagination"),
			clickable: true,
			renderBullet: (index: number, className: string) => {
				return `<span class="${className}" role="button" aria-label="Go to slide number ${index}" tabindex="0"></span>`;
			}
		};
	}
}

export default BaseSliderBlock;
